<template>
  <div class="over-money">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="客户名称" prop="accountId">
        <search-select
          v-model="form.accountId"
          type="customer"
          valueField="id"
          clearable
          placeholder="请输入客户名称"></search-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" @click="handleAdd" v-permission="'025010404'">新增</el-button>
        <el-button type="primary" @click="handleExport" v-permission="'025010403'">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="orgName"
        label="经营组织"
        width="200"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        width="200"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="totalRebateAmount"
        label="合计产生返优惠金额"
        width="160"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="balance"
        label="可用金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="usedAmount"
        label="已用金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="expiredAmount"
        label="已失效金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatStatus">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createPerson"
        label="创建人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="applyDate"
        label="审核时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button size="mini" @click="lookDetail(scope.$index, scope.row)" v-permission="'025010401'">
            明细
          </el-button>
          <el-button size="mini" @click="handleAdjust(scope.$index, scope.row)" v-permission="'025010402'">
            失效解冻
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <add-or-edit-dialog v-if="addOrEditDialogShow" @closeAdd="closeAdd"/>
    <add-modal v-if="adjustVisible" :show.sync="adjustVisible" @onform="forms" :formData="adjustData" :showType="showType" :handleSearch="handleSearch" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AjaxSelect from '../../../components/ajaxSelect/index'
import SearchSelect from '../../../components/searchSelect/index'
import addModal from '../rebateAccountRecordDm/addModal'
import AddOrEditDialog from './addOrEditDialog'

export default {
  name: 'differentiatedMarketingAccount',
  components: { AjaxSelect, SearchSelect, addModal, AddOrEditDialog },
  data () {
    return {
      form: {
        orgId: '',
        accountId: '',
        status: '',
        pageNo: 1,
        pageSize: 20000
      },
      sizeArr: [
        { value: '', label: '1000' },
        { value: 1, label: '5000' },
        { value: 2, label: '10000' },
        { value: 3, label: '20000' }
      ],
      addOrEditDialogShow: false,
      visibleCustomer: false,
      info: {},
      adjustVisible: false,
      adjustData: {},
      showType: 'fromAccount',
      statusList: [
        { value: 0, label: '待审核' },
        { value: 1, label: '已审核' },
        { value: 2, label: '审核未通过' }
      ]
    }
  },
  computed: {
    ...mapGetters({ list: 'getGeneratePolicyPageDm', listState: 'getGeneratePolicyStateDm' }),
    sizeNumber () {
      const maxNo = Math.ceil(this.listState.total / this.form.pageSize) + 1
      const newArr = [...new Array(maxNo).keys()]
      newArr.shift()
      return newArr
    }
  },
  methods: {
    ...mapActions(['rebateAccountPageDm', 'exportAccountDm']),
    // 搜索
    handleSearch () {
      this.adjustVisible = false
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log('[ this.form ] >', this.form)
          this.rebateAccountPageDm({ ...this.form, pageNo: 1, pageSize: 10 })
        } else {
          return false
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.rebateAccountPageDm({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.rebateAccountPageDm({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 导出
    handleExport () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportAccountDm({ ...this.form }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '返优惠账户.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    lookDetail (index, row) {
      this.$router.push({ name: 'differentiatedMarketingFlow', query: { id: row.id } })
    },
    handleAdjust (index, row) {
      this.adjustData = row
      this.adjustVisible = true
    },
    handleAdd () {
      this.addOrEditDialogShow = true
    },
    closeAdd (type) {
      this.addOrEditDialogShow = false
      if (type) {
        this.handleSearch()
      }
    },
    // 格式化状态
    formatStatus (row) {
      const status = this.$lodash.find(this.statusList, { value: row.status }) || {}
      return status.label
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>
  .output-box{
    margin-top: 20px;
    text-align: right;
  }
  .input-page, .select-page{
    width: 98px;
    margin: 0 15px;
  }
  .input-page, .select-page-btn{
    width: 120px;
    margin: 0 15px;
  }
</style>
